import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { EdgvrPortalFeatureHeaderModule } from '@edgvr-front/edgvr-portal/feature/header';
import Components from './components';

@NgModule({
  declarations: [...Components],
  imports: [CommonModule, RouterModule, EdgvrPortalFeatureHeaderModule],
  exports: [...Components],
})
export class EdgvrPortalFeatureTemplateModule {}
